import * as React from 'react';
import { LoadOptions } from 'app/types-shared';
import { CodeSinglePicker } from '../../common';
import { CodeCodetablePickerProps } from './types';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { CodeActionType } from 'app/area/codetable/item/types';
import { getDisabledValidation } from 'app/area/shared/codetable/item/codetable-item-helpers';
import { manageOptionsButton } from 'app/area/shared/manage-options';
import { CodeComplexValue } from 'app/area/shared/codetable/types';

export const CodeCategory = ({ breadcrumbs, metadata, codeItem, onChange,
  loadOptions, fetchingParentCategory, options, translation,
  validation, readOnly, actionType }: CodeCodetablePickerProps) => {

  if (!metadata || !metadata.codetableCategory || !isDefinedIncludingZero(metadata.codetableCategory.id)) {
    return null;
  }

  const onLoadOptions = (id: string, loadOptionsParams: LoadOptions) => {
    loadOptions(id, metadata.codetableCategory.id, loadOptionsParams);
  };

  const extraFooterButton = manageOptionsButton(translation.manage_options, metadata.codetableCategory.id, breadcrumbs);

  const codeOptions = (options && !!options.category && options.category.codes || []) as CodeComplexValue<number>[];

  const isCodeEditing = codeItem && isDefinedIncludingZero(codeItem.id);

  const isCodeDuplicating = actionType === CodeActionType.Duplicate;

  const categoryValidation = !!validation && !!validation.category ? validation.category : undefined;
  const finalValidation = {
    ...categoryValidation,
    ...getDisabledValidation(codeItem.category?.disabled, translation.selected_value_disabled)
  };

  const isCategoryReadOnly = fetchingParentCategory || (!isCodeDuplicating && (isCodeEditing || readOnly));

  return (
    <CodeSinglePicker
      id="category"
      label={metadata.codetableCategory.label ?? translation?.category}
      valueItem={codeItem && codeItem.category}
      searchRequired={metadata.codetableCategory.id && metadata.codetableCategory.searchRequired}
      required={!isCategoryReadOnly}
      options={codeOptions}
      fetchingOptions={(options.category && options.category.fetching)}
      showSpinnerLabel={fetchingParentCategory}
      validation={finalValidation}
      translation={translation}

      onLoadOptions={onLoadOptions}
      onChange={onChange}
      readOnly={isCategoryReadOnly}
      extraFooterButton={extraFooterButton}
    />
  );
};
